module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEX/zgAAAAAAAAD/zgDdAAD/3gD9wwDfCwDuAADSAAALAADld1weAAAAAnRSTlPy8gOq3TcAAABDSURBVEjH7crBFAAhAEXRpzAKo5BCCimkkEIKKUTZyeCtO/+uL5/ALyQlJd20BZbAFKhCUtLzaQh0gSZQhKSk55NxAOW2NrOJ+y9RAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/buttonCulture/de.png
// module id = 444
// module chunks = 0